module.exports = __webpack_public_path__ + "img/Andaluza-19-min.34fa500e.jpg";